import React from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import xplanLabels from "../../util/XplanLabels";
import HistoryLogElement from "./HistoryLogElement";
import GroupAllUsers from "../FieldTags/GroupAllUsers";

const newPlan = window.location.pathname === "/xplans/new";

const SiteAgreementStatus = ({ siteAgreementStatus, handleChange, xplans }) => {
    return (
        <div id="siteAgreementStatus" className="planField">
            <GroupAllUsers />
            <FormControl>
                <FormLabel className="planRadioTitle">
                    {xplanLabels.siteAgreementStatus}
                </FormLabel>
                <RadioGroup
                    name="siteAgreementStatus"
                    label={xplanLabels.siteAgreementStatus}
                    value={siteAgreementStatus}
                    onChange={(e) => handleChange("siteAgreementStatus", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="N/A"
                        control={<Radio />}
                        label="N/A"
                    />
                    <FormControlLabel
                        value="Sent"
                        control={<Radio />}
                        label="Sent"
                    />
                    <FormControlLabel
                        value="Executed"
                        control={<Radio />}
                        label="Executed"
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"siteAgreementStatus"} /> }
        </div>
    );
};

export default SiteAgreementStatus;